"use strict";
const _ = require('lodash');
const cellDivider = ' | ';
const rowStart = '| ';
const rowEnd = ' |';
const rowDivider = '\n';
const minColumnWidth = ':---'.length;
function alignment(cd) {
    switch (cd.alignment) {
        case 'right':
            return _.padStart(':', cd.length, '-');
        case 'center':
            return `:${_.padStart(':', cd.length - 1, '-')}`;
        case 'left':
        default:
            return _.padEnd(':', cd.length, '-');
    }
}
const alignCellContent = columnDefinitions => (data, index) => {
    switch (columnDefinitions[index].alignment) {
        case 'right':
            return _.padStart(data, columnDefinitions[index].length, ' ');
        case 'center':
            return _.pad(data, columnDefinitions[index].length, ' ');
        case 'left':
        default:
            return _.padEnd(data, columnDefinitions[index].length, ' ');
    }
};
module.exports = {
    tableBuilder: (columnDefinitionsInput, rows) => {
        const columnDefinitions = [...columnDefinitionsInput];
        const allRowsControllingLength = [
            columnDefinitions.map(cd => cd.header),
            ...rows,
        ];
        allRowsControllingLength.forEach(row => row.forEach((column, index) => {
            columnDefinitions[index].length = Math.max((_.get(column, 'header') || column || '').length, _.get(columnDefinitions[index], 'header', '').length, minColumnWidth);
        }));
        const addRowEdges = row => `${rowStart}${row}${rowEnd}`;
        const tableHeader = addRowEdges(columnDefinitions
            .map(cd => _.pad(cd.header, cd.length, ' '))
            .join(cellDivider));
        const tableAlignmentRow = addRowEdges(columnDefinitions.map(alignment).join(cellDivider));
        const tableBody = rows
            .map(row => row.map(alignCellContent(columnDefinitions)).join(cellDivider))
            .map(row => addRowEdges(row))
            .join(rowDivider);
        return [tableHeader, tableAlignmentRow, tableBody].join(rowDivider);
    },
    buttonBuilder: (text, linkUrl, color) => {
        const btnColor = color ? `btn-${color}` : 'btn';
        return `
<p style="text-align:center">
<a href="${linkUrl}" class="${btnColor}" target="_blank">${text}</a>
</p>
  `;
    },
    horizontalRule: `
    ___
    `,
};
